

























































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { ConversationViewModel } from '@/views/claude/conversationViewModel';
import { userService } from '@/shared';
import { BotConversationViewModel } from './botConversationHistory';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import Axios from 'axios';
import { Utils } from '@/helper/utils';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import * as dhx from 'dhx-richtext';
import * as marked from 'marked';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        previewText() {
            return marked(this.md_text);
        },
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        AppDialog: () => import('@/components/common/app.dialog.vue'),
        Richtext,
    },
})
export default class BotTrainingListPage extends Base {

    public dataType: { type: string; default: 'markdown' };
    public richtext: Richtext;
    public markdown: string = '';
    public divClass: string = 'hidden';

    public css: string = '';
    public mode: { type: string; default: 'classic' };
    public loading: boolean = false;
    public disableSubmitButton: boolean = false;
    public roNumber: string = "";
    public initialMessage: string = "";
    public roResponse: any = {};
    public conversationHistory: BotConversationViewModel[] = [];
    public todaysDate: any = _dateTime.currentDate(new Date());
    public primaryPrompt: string = "";
    public supplementaryPrompt: string = "";
    public BotFeedbackCategorizationPrompt: string = "";
    public postToBotLoading: boolean = false;
    public displayResponse: string = "";
    public isNegativeResponseExist: boolean = false;
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'botTraining');
        this.conversationHistory = [];
        this.richtext = new Richtext(this.$refs.container, {
            mode: this.mode,
            css: this.css,

        });
    }
    public scrollToBottom() {
        this.$nextTick(() => {
            const messageContainer = this.$refs.messageContainer as HTMLElement;
            if (messageContainer) {
                messageContainer.scrollTop = messageContainer.scrollHeight;
            }
        });
    }
    public created() {
        dhx.i18n.setLocale('richtext', this.$t('richText'));
    }
    public async getRoDetails(): Promise<void> {
        if (!this.roNumber) {
            this.showAlert(false, "RO Number can't be empty");
            return;
        }
        try {
            this.loading = true;
            this.conversationHistory = [];
            this.initialMessage = "";
            this.primaryPrompt = "";
            this.supplementaryPrompt = "";
            const response = await userService.GetRONumberDetailForPrompt(this.roNumber);
            this.conversationHistory = response.conversationHistory;
            this.primaryPrompt = response.primaryPrompt;
            // this.supplementaryPrompt = response.supplementaryPrompt ? response.supplementaryPrompt : response.primaryPrompt;
            this.supplementaryPrompt = response.supplementaryPrompt ? response.supplementaryPrompt : "";
            this.roResponse = response;
            this.isNegativeResponseExist = this.roResponse.isNegativeResponseExist;
            this.markdown = this.supplementaryPrompt;
            if (this.supplementaryPrompt != "") {
                this.divClass = 'block';
            } else {
                this.divClass = 'hidden';
            }
            this.richtext.setValue(this.markdown, this.dataType);

        }
        finally {
            this.loading = false;
            this.postToBotLoading = false;
            this.displayResponse = "";
        }

    }
    public submitToBot() {
        if (!this.roNumber) {
            this.showAlert(false, "RO Number can't be empty");
            return;
        }
        // else if (!this.supplementaryPrompt) {
        //     this.showAlert(false, "RO Number can't be empty");
        //     return;
        // }
        else if (!this.initialMessage) {
            this.showAlert(false, "Follow up message can't be empty");
            return;
        }
        const newMessage: any = {
            role: 'user',
            content: this.initialMessage,
        };
        this.supplementaryPrompt = this.richtext.getValue('markdown');
        try {

            this.postToBotLoading = true;
            this.conversationHistory.push(newMessage);
            this.$nextTick(() => {
                this.scrollToBottom();
            });
            const html = marked(this.supplementaryPrompt);
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            this.supplementaryPrompt = doc.body.textContent || "";

            Axios({
                method: 'post',
                url: Utils.WEB_BASE_URL + "/web/analyzeMessage",
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {
                    ConversationHistory: this.conversationHistory,
                    Email: this.roResponse.email,
                    FirstName: this.roResponse.firstName,
                    LastName: this.roResponse.lastName,
                    Make: this.roResponse.make,
                    Model: this.roResponse.model,
                    ModelYear: this.roResponse.modelYear,
                    MessageId: this.roResponse.messageId,
                    PhoneNumber: this.roResponse.phoneNumber,
                    VIN: this.roResponse.vin,
                    AdvisorFirstName: this.roResponse.advisorFirstName,
                    AdvisorLastName: this.roResponse.advisorLastName,
                    AdvisorEmail: this.roResponse.advisorEmail,
                    RoNumber: this.roNumber,
                    ServiceManagerFirstName: this.roResponse.serviceManagerFirstName,
                    ServiceManagerLastName: this.roResponse.serviceManagerLastName,
                    ServiceWriterId: this.roResponse.serviceWriterId,
                    ServiceWriterName: this.roResponse.serviceWriterName,
                    StoreTimeZone: this.roResponse.storeTimeZone,
                    DealerCode: this.roResponse.dealerCode,
                    PositiveFeedback: this.roResponse.positiveFeedback,
                    NegativeFeedback: this.roResponse.negativeFeedback,
                    JobPerformed: this.roResponse.jobPerformed,
                    Services: this.roResponse.services,
                    DefaultServices: this.roResponse.defaultServices,
                    PrimaryPrompt: this.roResponse.primaryPrompt,
                    SupplementaryPrompt: this.supplementaryPrompt,
                    BotFeedbackCategorizationPrompt: this.roResponse.botFeedbackCategorizationPrompt,
                    StoreId: this.roResponse.storeId,
                    EnterpriseId: this.roResponse.enterpriseId,
                    TenantId: this.roResponse.tenantId,
                    IsTrainingTool: this.roResponse.isTrainingTool,
                    IsNegativeResponseExist : this.isNegativeResponseExist,
                    CustomerNumber : this.roResponse.customerNumber
                },

            }).then((response) => {

                this.postToBotLoading = false;
                if (response != null && response != undefined && response.data != '') {
                    var model = { role: "", content: "" };
                    model.role = "assistant";
                    // model.content = response.data.content;
                    const contentArray = response.data.content.split('¤¤');
                    if (contentArray.length > 0) {
                        model.content = contentArray[0] || ''; // Default to an empty string if [0] is undefined
                        this.displayResponse = contentArray[1] || '';
                        if(contentArray[2].toLowerCase() == "negative")
                        {
                            this.isNegativeResponseExist = true;
                        }
                    } else {
                        model.content = contentArray[0] || ''; // Default to an empty string if [0] is undefined
                    }
                    this.conversationHistory.push(model);
                    this.initialMessage = "";
                    this.scrollToBottom();
                }
                else {
                    this.showAlert(false, "Please try again later");
                }
            });
        } catch (e) {
            console.log(e);
            if (this.conversationHistory && this.conversationHistory.length > 0) {
                this.conversationHistory.pop();
            }
            this.showAlert(false, "Please try again later");
            this.postToBotLoading = false;
        }

    }

}
